import { ReduxUtils } from '../dependencies';

export const Level = ReduxUtils.strictObjectAccess({
    SUCCESS: 'success',
    ERROR: 'error',
});
